import React from "react";

import Editor from './ASpecialDaysCounterEditor'
import EditorWrapper from '../../EditorWrapper'

import SpecialDaysCounter from "../../common/SpecialDaysCounter";
import EmptyArticle from "../../common/EmptyArticle";

const ASpecialDaysCounter = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.link = settings.link;
    article.title_normal = settings.title_normal;

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <SpecialDaysCounter
                article={article}
                {...props}
            />
        </div>
    );
};


export default ASpecialDaysCounter;